import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { LoaderProps } from '../../helpers/types';

const Loader = ({ size, color }: LoaderProps) => {
  return <CircularProgress size={size} color={color} />;
};

export default Loader;
